import React, {Component} from 'react';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import Boxes from '../components/boxes'

import {setDrag, rmvItem, moveBox, saveDrag} from '../actions'

// import camera from "../helpers/camera-helper"

const mapStateToProps = (state) => {
    // console.log(state.sceneItems.spaces[state.sceneItems.curSpaceId])
    return {
        // sceneItems: state.sceneItems.el,
        sceneItems: state.sceneItems.spaces[state.sceneItems.curSpaceId].el,
        // camera: state.camera  //camera.rot
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setDrag: setDrag,
        rmvItem: rmvItem,

        moveBox: moveBox,

        saveDrag: saveDrag,
    }, dispatch);

}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(Boxes);



// WEBPACK FOOTER //
// ./src/containers/boxes.js